module.exports = __webpack_public_path__ + "img/未标题-3-09.faecd91a.png";